/**
 * Cart subscription controls.
 *
 * The rendered cart row is authoritative for display state. A subscription
 * mutation returns the full cart and both cart sections, so no follow-up cart
 * reads or per-render listener rebinding are needed.
 */
(function () {
  if (window.__fourPawCartSubscriptions) return;
  window.__fourPawCartSubscriptions = true;

  function updateSelectForCurrentSubscription(itemRow) {
    const select = itemRow.querySelector(".cart-item__subscribe-frequency-select");
    const planId = String(itemRow.dataset.currentSellingPlanId || "");
    if (!select || !planId) return;

    const matchingOption = Array.from(select.options).find((option) =>
      option.value !== "unsubscribe" && String(option.dataset.planId || option.value.split("-")[0]) === planId
    );
    if (matchingOption) select.value = matchingOption.value;
  }

  function updateSubscribeButtons() {
    document.querySelectorAll('.cart-item[data-has-selling-plans="true"]').forEach((itemRow) => {
      const buttonWrapper = itemRow.querySelector(".cart-item__subscribe-button-wrapper");
      const options = itemRow.querySelector(".cart-item__subscribe-options");
      const subscriptionName = itemRow.querySelector(".cart-item__subscription-name");
      const hasSubscription = String(
        options?.dataset.hasSubscription || buttonWrapper?.dataset.hasSubscription || "false"
      ) === "true";
      const totalOptions = Number.parseInt(
        options?.dataset.totalOptions ||
        buttonWrapper?.querySelector(".cart-item__subscribe-button")?.dataset.totalOptions ||
        "0",
        10,
      );

      if (buttonWrapper) buttonWrapper.style.display = hasSubscription ? "none" : "";
      if (options) options.style.display = hasSubscription && totalOptions > 1 ? "flex" : "none";
      if (subscriptionName) subscriptionName.style.display = hasSubscription && totalOptions <= 1 ? "" : "none";
      if (hasSubscription && totalOptions > 1) updateSelectForCurrentSubscription(itemRow);
    });
  }

  async function updateCartItemSellingPlan(lineItemKey, sellingPlanId) {
    if (!lineItemKey) return;
    await window.fourPawCartWork?.settled;
    const finish = window.fourPawCartWork?.begin();
    if (window.fourPawCartWork && !finish) return;

    try {
      const root = window.Shopify?.routes?.root || "/";
      const request = window.fourPawCartFetch || window.fetch.bind(window);
      const response = await request(`${root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: lineItemKey,
          selling_plan: sellingPlanId || "",
          sections: ["cart-drawer", "cart-icon-bubble"],
          sections_url: window.location.pathname,
        }),
      });
      const parsedState = await response.json();
      if (!response.ok || parsedState.errors || parsedState.status) {
        throw new Error(parsedState.description || parsedState.message || "Unable to update subscription.");
      }

      const drawer = document.querySelector("cart-drawer");
      if (!drawer?.renderContents || !parsedState.sections?.["cart-drawer"]) {
        throw new Error("The updated cart is unavailable.");
      }
      drawer.renderContents(parsedState, false, true);

      const controller = drawer.querySelector("cart-drawer-items") || document.querySelector("cart-items");
      if (controller?.normalizeFourPawSafeWalkCart) {
        const normalized = await controller.normalizeFourPawSafeWalkCart(parsedState);
        await controller.fourPawRefreshCart(normalized.cart, true);
      } else if (window.publish && window.PUB_SUB_EVENTS) {
        await window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-subscription",
          cartData: parsedState,
          sectionsRendered: true,
        });
      }
      updateSubscribeButtons();
    } catch (error) {
      window.fourPawCartWork?.fail();
      const errors = document.getElementById("CartDrawer-CartErrors");
      if (errors) errors.textContent = error instanceof Error ? error.message : window.cartStrings.error;
      console.error("Error updating cart item selling plan:", error);
    } finally {
      finish?.();
    }
  }

  function handleSubscribeButtonClick(event) {
    const button = event.target.closest?.(".cart-item__subscribe-button");
    if (!button) return;
    event.preventDefault();

    const itemRow = button.closest(".cart-item");
    const options = itemRow?.querySelector(".cart-item__subscribe-options");
    const select = options?.querySelector(".cart-item__subscribe-frequency-select");
    const totalOptions = Number.parseInt(button.dataset.totalOptions || "0", 10);
    const firstPlanId = button.dataset.firstPlanId || select?.options?.[0]?.dataset?.planId;

    if (totalOptions > 1 && options) {
      button.closest(".cart-item__subscribe-button-wrapper").style.display = "none";
      options.style.display = "flex";
      itemRow.querySelector(".cart-item__subscription-name")?.style.setProperty("display", "none");
    }
    if (firstPlanId) updateCartItemSellingPlan(button.dataset.lineItemKey, firstPlanId);
  }

  function handleFrequencySelectChange(event) {
    const select = event.target.closest?.(".cart-item__subscribe-frequency-select");
    if (!select) return;
    const selectedOption = select.options[select.selectedIndex];
    const sellingPlanId = select.value === "unsubscribe"
      ? ""
      : String(selectedOption?.dataset.planId || select.value.split("-")[0] || "");
    updateCartItemSellingPlan(select.dataset.lineItemKey, sellingPlanId);
  }

  document.addEventListener("click", handleSubscribeButtonClick);
  document.addEventListener("change", handleFrequencySelectChange);
  document.addEventListener("cart-drawer:render", updateSubscribeButtons);
  if (window.subscribe && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, updateSubscribeButtons);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateSubscribeButtons, { once: true });
  } else {
    updateSubscribeButtons();
  }
})();
